<template>
  <template v-if="!loading && detail">
    <commandes-details-main v-bind:detail="detail" />
    <refonte-collapse
      v-if="
        detail &&
        (detail?.inscriptions?.length || detail?.autresArticles?.length)
      "
      class="mt-[12px]"
      v-bind:title_icon="IconFormations"
      title="Inscriptions"
      v-bind:start_open="true">
      <template
        v-if="
          detail?.inscriptions?.length > 0 || detail?.autresArticles?.length > 0
        ">
        <div
          v-bind:key="`inscription-${index}`"
          v-for="(inscription, index) in detail.inscriptions"
          class="inscription_item">
          <refonte-separator
            v-if="index > 0 && detail.inscriptions.length > 1"
            class="inscription-item-separator" />
          <refonte-table
            v-bind:key="`inscription-${index}`"
            v-bind:table_index="`inscription-${index}`"
            v-bind:columns="columnsInscriptions"
            v-bind:data="[formatInscription(inscription)]"
            class="inscription-item-table">
          </refonte-table>
          <div
            class="inscription-item-content"
            v-if="inscription?.participants?.length">
            <refonte-label label="Participants" />
            <refonte-collapse
              v-bind:key="`participant-${index}-${indexParticipant}`"
              v-for="(
                participant, indexParticipant
              ) in inscription.participants"
              class="!bg-refonte-pale-violet-2"
              v-if="inscription?.participants?.length > 0"
              v-bind:title="`${participant.nomPrenom} ${participant.statut ? `(${participant.statut})` : ''}`"
              v-bind:start_open="true"
              v-bind:header_blue="false"
              v-bind:class="indexParticipant > 0 ? 'mt-[12px]' : ''"
              v-bind:content_class="participant.prestations ? '!p-0' : ''">
              <template
                v-if="
                  participant.prestations && participant.prestations.length
                ">
                <refonte-table
                  v-bind:key="`prestations-${index}-${indexParticipant}`"
                  v-bind:table_index="`prestations-${index}-${indexParticipant}`"
                  v-bind:columns="columnsPrestations"
                  v-bind:data="participant.prestations">
                </refonte-table>
              </template>
              <template v-else />
            </refonte-collapse>
          </div>
          <div
            class="inscription-item-content"
            v-if="inscription?.prestations.length">
            <refonte-label label="Frais fixes" />
            <refonte-card class="!bg-refonte-pale-violet-2 !p-0">
              <template v-if="inscription?.prestations.length > 0">
                <refonte-table
                  v-bind:key="`prestations-${index}-fixe`"
                  v-bind:table_index="`prestations-${index}-fixe`"
                  v-bind:columns="columnsPrestations"
                  v-bind:data="inscription.prestations">
                </refonte-table>
              </template>
              <refonte-search-results-empty v-else />
            </refonte-card>
          </div>
        </div>
        <template
          v-if="detail.autresArticles && detail.autresArticles.length > 0">
          <refonte-separator v-if="detail?.inscriptions?.length > 0" />
          <div class="synthese">
            <refonte-label label="Autres articles" />
            <refonte-card class="!bg-refonte-pale-violet-2 !p-0">
              <div
                v-for="(article, index) in detail.autresArticles"
                v-bind:key="`article-${index}`"
                class="inscription_item">
                <refonte-table
                  v-bind:key="`prestations-${index}-fixe`"
                  v-bind:table_index="`prestations-${index}-fixe`"
                  v-bind:columns="columnsPrestations"
                  v-bind:data="[article]" />
              </div>
            </refonte-card>
          </div>
        </template>

        <template v-if="detail.synthese">
          <refonte-separator />
          <div class="synthese">
            <refonte-label label="Synthèse" />
            <refonte-card class="!bg-refonte-pale-violet-2 !p-0">
              <refonte-table
                key="prestations-synthese"
                table_index="prestations-synthese"
                v-bind:columns="columnsSynthese"
                v-bind:data="[detail.synthese]">
              </refonte-table>
            </refonte-card>
          </div>
        </template>
      </template>
      <refonte-search-results-empty v-else />
    </refonte-collapse>
    <refonte-collapse
      v-if="detail && detail.factures?.length"
      class="mt-[12px]"
      v-bind:title_icon="IconFactures"
      title="Factures"
      v-bind:start_open="true">
      <template v-if="detail.factures && detail.factures.length > 0">
        <refonte-table
          key="factures-1"
          table_index="factures-1"
          v-bind:columns="columnsFactures"
          v-bind:data="detail.factures">
        </refonte-table>
      </template>
      <refonte-search-results-empty v-else />
    </refonte-collapse>
    <refonte-collapse
      v-if="detail.reglements && detail.reglements.length > 0"
      class="mt-[12px]"
      v-bind:title_icon="IconFactures"
      title="Règlements"
      v-bind:start_open="true">
      <refonte-table
        key="reglements-1"
        table_index="reglements-1"
        v-bind:columns="columnsReglements"
        v-bind:data="detail.reglements"
        class="table-no-space-between">
      </refonte-table>
    </refonte-collapse>
  </template>
  <spinner
    v-else
    sizes="w-20 h-20"
    thickness="border-8" />
</template>
<script setup lang="ts">
  import Spinner from '@/components/utils/spinner.vue';
  import { h, onMounted, ref } from 'vue';
  import RefonteCollapse from '@/components/refonte/collapse/refonte-collapse.vue';
  import IconFactures from '@/assets/img/refonte/icons/menu/icon-bills.svg?component';
  import IconDownload from '@/assets/img/refonte/icons/display/icon-download.svg?component';
  import IconFormations from '@/assets/img/refonte/icons/menu/icon-training.svg?component';
  import RefonteSearchResultsEmpty from '@/components/refonte/inputs/refonte-search-results-empty.vue';
  import RefonteTable from '@/components/refonte/tables/refonte-table.vue';
  import number_utils from '@/mixin/number_utils';
  import CommandesDetailsMain from '@/views/_espace/_refonte/gestion/_commandes-details/commandes-details-main.vue';
  import RefonteLabel from '@/components/refonte/inputs/refonte-label.vue';
  import RefonteCard from '@/components/refonte/cards/refonte-card.vue';
  import RefonteSeparator from '@/components/refonte/separators/refonte-separator.vue';
  import { PrestationPrice } from '@/types/gestion/inscriptions-details-types';
  import { useRoute } from 'vue-router';
  import { API } from '@/http-common';
  import { Facture } from '@/types/gestion/factures-types';
  import {
    buildProduitTypeLabel,
    buildProduitTypeShortcut
  } from '@/stores/utils';
  import { downloadFacture } from '@/mixin/client_download__functions';
  import { IdLabel } from '@/types/gestion/entreprise';
  import { useEntrepriseStore } from '@/stores/entreprise';
  import { storeToRefs } from 'pinia';
  import CommandesTableItemPaiementInstruction from '@/views/_espace/_refonte/gestion/_commandes/commandes-table-item-paiement-instruction.vue';
  import {
    Reglement,
    ReglementResponse
  } from '@/types/gestion/commandes-types';

  const detail = ref();
  const loading = ref<boolean>(false);

  const route = useRoute();
  const { reference } = route.query;
  const entrepriseStore = useEntrepriseStore();
  const { entreprises } = storeToRefs(entrepriseStore);

  const entreprisesId = entreprises.value.map((e) => e.entrepriseId);

  const fetchCommande = async () => {
    if (reference) {
      const response = await API.get(`client/v2/commande/${reference}/details`);
      if (response && response.data) {
        detail.value = mapDetail(response.data);
      }
    }
  };
  const mapDetail = (detail) => {
    return {
      ...detail,
      inscriptions: detail.inscriptions?.map((f) => mapInscription(f)),
      factures: detail.factures?.map((f) => mapFacture(f)),
      synthese: {
        ...detail.synthese,
        reglement: detail.synthese?.reglement
          ? buildReglement(detail.synthese.reglement)
          : undefined,
        montantRegle: detail.montantRegle
      }
    };
  };

  const mapInscription = (inscription) => {
    let date;
    if (inscription.dateDebut && inscription.dateFin) {
      if (inscription.dateDebut == inscription.dateFin) {
        date = `${inscription.dateDebut}`;
      } else {
        date = `${inscription.dateDebut} - ${inscription.dateFin}`;
      }
    }
    return {
      ...inscription,
      participants: inscription.participants?.map((i) => mapParticipant(i)),
      date
    };
  };
  const mapFacture = (f) => {
    return {
      ...f,
      referenceEtType: `${f.type ? `${f.type} : ` : ''}${f.reference}`,
      statutLabel: f.statut ? [f.statut.label] : [],
      statutVariant: buildStatutVariant(f.statut),
      factureNom: entreprisesId.includes(f.etablissementId)
        ? f.factureNom
        : undefined
    };
  };
  const mapParticipant = (participant) => {
    return {
      ...participant,
      nomPrenom: `${participant.nom ?? 'Réservation'} ${participant.prenom ?? ''}`
    };
  };

  onMounted(async () => {
    loading.value = true;
    await fetchCommande();
    loading.value = false;
  });

  const formatInscription = (i) => {
    return {
      ...i,
      typeShortcut: buildProduitTypeShortcut(i.type.id, i.lienElearning),
      typeLabel: buildProduitTypeLabel(i.type.label, i.lienElearning)
    };
  };
  const buildStatutVariant = (statut?: IdLabel) => {
    const variant =
      statut && statut.label === 'Acquittée'
        ? 'success'
        : statut && statut.label === 'Non acquittée'
          ? 'warning'
          : 'deactivated';
    return [variant];
  };

  const columnsInscriptions = [
    {
      content_index: 'titre',
      tags_type: 'typeShortcut',
      tags_type_label: 'typeLabel',
      date: 'date',
      content_sub_text: (row: any) =>
        `${row.reference ? `Réf. : ${row.reference}` : ''}`,
      width: 360
    },
    {
      content_index: 'site',
      label: 'Site',
      width: 360
    }
  ];

  const columnsFactures = [
    {
      content_index: 'etablissement',
      content_sub_text: (row: any) =>
        h('span', {
          innerHTML: row.etablissementSiret
            ? 'SIRET : ' + row.etablissementSiret
            : ''
        }),
      label: 'Etablissement',
      width: 308
    },
    {
      content_index: 'referenceEtType',
      label: 'Type',
      tags_type: 'statutVariant',
      tags_type_label: 'statutLabel',
      content_sub_text: (row: Facture) =>
        row.date && row.date !== '-' ? row.date : undefined,
      width: 200
    },

    {
      content_index: 'montant',
      label: 'Montant',
      width: 120,
      content_custom: (row: any) =>
        h('span', {
          innerHTML: number_utils.methods.formatCurrency(row.montant)
        })
    },
    {
      content_index: 'montantRegle',
      label: 'Payé',
      width: 120,
      content_custom: (row: any) =>
        h('span', {
          innerHTML: number_utils.methods.formatCurrency(row.montantRegle)
        })
    },
    {
      content_index: 'factureNom',
      label: 'Facture',
      width: 140,
      on_click: (row: Facture) => {
        return row.factureNom
          ? downloadFacture(detail.value.payeur.id, row.id)
          : undefined;
      },
      content_icon: (row: Facture) =>
        row.factureNom ? IconDownload : undefined,
      class: (row: Facture) => '!flex-grow-0'
    }
  ];

  const columnsReglements = [
    {
      content_index: 'date',
      label: 'Date',
      width: 308
    },
    {
      content_index: 'reference',
      label: 'Référence',
      width: 180
    },
    {
      content_index: 'montant',
      label: 'Montant',
      width: 120,
      content_custom: (row: any) =>
        h('span', {
          innerHTML: number_utils.methods.formatCurrency(row.montant)
        })
    },
    {
      content_index: 'mode',
      label: 'Mode',
      width: 180
    }
  ];

  const columnsPrestations = [
    {
      content_index: 'libelle',
      label: 'Libellé',
      width: 308
    },
    {
      content_index: 'montantHT',
      label: 'Montant HT',
      width: 120,
      content_custom: (row: PrestationPrice) =>
        h('span', {
          innerHTML: number_utils.methods.formatCurrency(row.montantHT)
        })
    },
    {
      content_index: 'montantTVA',
      label: 'Montant TVA',
      width: 120,
      content_custom: (row: PrestationPrice) =>
        h('span', {
          innerHTML: number_utils.methods.formatCurrency(row.montantTVA)
        })
    },
    {
      content_index: 'montantTTC',
      label: 'Montant TTC',
      width: 120,
      content_custom: (row: PrestationPrice) =>
        h('span', {
          innerHTML: number_utils.methods.formatCurrency(row.montantTTC)
        })
    }
  ];

  const columnsSynthese = [
    {
      content_index: 'libelle',
      label: 'Libellé',
      width: 308
    },
    {
      content_index: 'montantHT',
      label: 'Montant HT',
      width: 120,
      content_custom: (row: PrestationPrice) =>
        h('span', {
          innerHTML: number_utils.methods.formatCurrency(row.montantHT)
        })
    },
    {
      content_index: 'montantTVA',
      label: 'Montant TVA',
      width: 120,
      content_custom: (row: PrestationPrice) =>
        h('span', {
          innerHTML: number_utils.methods.formatCurrency(row.montantTVA)
        })
    },
    {
      content_index: 'montantTTC',
      label: 'Montant TTC',
      width: 120,
      content_custom: (row: PrestationPrice) =>
        h('span', {
          innerHTML: number_utils.methods.formatCurrency(row.montantTTC)
        })
    },
    {
      content_index: 'montantRegle',
      label: 'Réglé',

      min_width: 85,
      width: 200,
      content_custom_with_on_click: (row: PrestationPrice) =>
        !row.reglement?.label,
      content_custom: (row: PrestationPrice) =>
        h(CommandesTableItemPaiementInstruction, {
          montant_regle: number_utils.methods.formatCurrency(row.montantRegle),
          montant_ttc: number_utils.methods.formatCurrency(row.montantTTC),
          reglement: row.reglement
        })
    }
  ];

  const buildReglement = (reglement: ReglementResponse): Reglement => {
    const result: Reglement = {
      label: reglement.modeReglementLabel
    };
    switch (reglement.modeReglementId) {
      case 1:
        if (reglement.chequeAccept) {
          return {
            ...result,
            instructions: reglement.chequeInstruction
          };
        }
        break;
      case 2:
        if (reglement.virementAccept) {
          return {
            ...result,
            instructions: reglement.virementInstruction
          };
        }
        break;
      case 3:
        if (reglement.cbAccept) {
          return { ...result, instructions: reglement.cbInstruction };
        }
        break;
      case 5:
        if (reglement.sepaAccept) {
          return {
            ...result,
            instructions: reglement.sepaInstruction
          };
        }
        break;
      default:
        break;
    }
    return result;
  };
</script>

<style lang="scss" scoped>
  .table-no-space-between {
    :deep(.table-row-content) {
      justify-content: flex-start !important;

      .refonte-table-item {
        flex-grow: 0 !important;
      }
    }
  }
  .inscription_item {
    padding-bottom: 16px;

    .inscription-item-separator {
      padding-bottom: 8px;
    }
    .inscription-item-table {
      padding-bottom: 0 !important;
    }
    .inscription-item-content {
      gap: 8px;
      padding: 6px 20px;
      min-width: 100%;
    }
  }
  .synthese {
    padding: 16px 20px;
  }
</style>
